exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._MhG5{display:flex;padding:0;cursor:pointer;transition-duration:.2s;transition-property:opacity;opacity:1;border:0;border-radius:0;outline:none;background-color:transparent;justify-content:center;align-items:center}._MhG5:hover{opacity:.7}._1pN59{visibility:hidden!important;width:0!important;min-width:0!important;height:0!important;min-height:0!important;margin:0!important;padding:0!important;opacity:0!important}._2fnYp{z-index:50;display:flex;flex-direction:column-reverse;pointer-events:none;background-color:#000;align-items:center}._2fnYp,._1tQBd{position:absolute;top:0;right:0;bottom:0;left:0}._1tQBd{z-index:2;opacity:.5}", ""]);

// exports
exports.locals = {
	"controlButton": "_MhG5",
	"hidden": "_1pN59",
	"container": "_2fnYp",
	"frame": "_1tQBd"
};